import { WppButton, WppTypography } from '@wppopen/components-library-react'
import styles from './RenderEmptyProjectRegion.module.scss'

interface RenderEmptyProjectRegionProps {
  onClick: () => void
  permissions?: {
    canPostProjectRegion: boolean
  }
  isLoading?: boolean
}

export default function RenderEmptyProjectRegion({ onClick, permissions, isLoading }: RenderEmptyProjectRegionProps) {
  if (isLoading) return null

  return (
    <div className={styles.container} data-testid="empty-project-region">
      <WppTypography type="s-strong" data-testid="no-region-found">
        To start uploading data to the project you must add a region
      </WppTypography>
      {permissions?.canPostProjectRegion && (
        <WppButton variant="secondary" onClick={onClick} data-testid="add-region-button">
          Add region
        </WppButton>
      )}
    </div>
  )
}
